import { LucideBuilding, LucideProps, LucideServer, LucideSmartphone } from 'lucide-react';
import { z } from 'zod';

export const ProxyTypeZodEnum = z.enum(['mobile', 'residential', 'datacenter']);
export type ProxyTypeName = z.infer<typeof ProxyTypeZodEnum>;

export const ProxyTypeMetaZod = z.object({
  name: ProxyTypeZodEnum,
  price: z.number(),
  priceCents: z.number().int(),
  priceStr: z.string(),
  title: z.string(),
  description: z.string(),
  Icon: z.custom<React.ForwardRefExoticComponent<Omit<LucideProps, "ref"> & React.RefAttributes<SVGSVGElement>>>(),
  postfix: z.string(),
  defaultProxyPoolName: z.string()
});

export type ProxyTypeMeta = z.infer<typeof ProxyTypeMetaZod>;

export const residential: ProxyTypeMeta = {
  name: 'residential',
  price: 2.95,
  priceCents: 295,
  priceStr: '$2.95',
  title: 'Residential',
  description: 'Best used for: generate leads, run ads, scrape data',
  Icon: LucideBuilding,
  postfix: '_r',
  defaultProxyPoolName: 'Default residential proxy pool'
} as const;

export const mobile: ProxyTypeMeta = {
  name: 'mobile',
  price: 2.95,
  priceCents: 295,
  priceStr: '$2.95',
  title: 'Mobile',
  description: 'Rotating IPs from real mobile devices',
  Icon: LucideSmartphone,
  postfix: '_m',
  defaultProxyPoolName: 'Default mobile proxy pool'
} as const;

export const datacenter: ProxyTypeMeta = {
  name: 'datacenter',
  price: 0.9,
  priceCents: 90,
  priceStr: '$0.90',
  title: 'Data center',
  description: '245K data center proxies in 176 countries.',
  Icon: LucideServer,
  postfix: '_dc',
  defaultProxyPoolName: 'Default data center proxy pool'
} as const;


export const ProxyTypeMetas = {
  residential,
  mobile,
  datacenter,
} as const;

export type ProxyServerType = {
  username: string;
  password: string;
  port: number;
  host: string;
  countryCode: string;
  city?: string;
};


export const getProxyTypeMetaByName = (name: string | undefined | null) => {
  if ('residential' === name) {
    return residential;
  }
  if ('mobile' === name) {
    return mobile;
  }
  if ('datacenter' === name) {
    return datacenter;
  }
  if ('dataCenter' === name) {
    return datacenter;
  }
  throw new Error('Unknown proxy: ' + name);
}


